<soft-page>
  <!--soft-meta-form [form]="customForm" [meta]="meta"></soft-meta-form-->
  <!--soft-customer-search-input></soft-customer-search-input-->
  <soft-dashboard></soft-dashboard>
</soft-page>
